import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PersonalFileInfo } from 'projects/admin/src/lib/modules/shared/models/PersonalFileInfo';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'delete-file-dialog',
  templateUrl: './delete-file-dialog.component.html',
  styleUrls: ['./delete-file-dialog.component.css']
})
export class DeleteFileDialogComponent implements OnInit {

  fileDeleteForm!: FormGroup;
  fileInfo!:PersonalFileInfo;
//  userName!: string;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DeleteFileDialogComponent>,
    private tenantService: TenantService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) 
  { }

  ngOnInit() {

    this.fileInfo = this.data.fileInfo;
    console.log("========================> fileInfo = ", this.fileInfo);
    this.buildFileDeleteForm(this.fileInfo);
  }

  buildFileDeleteForm(file: PersonalFileInfo) {
    this.fileDeleteForm = this.fb.group({
      fileName:[this.fileInfo.fileName]
    });
  }

  deleteFile(fileName: string) {
    if(this.fileDeleteForm.valid){      
      this.dialogRef.close(this.fileDeleteForm.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }
}
